import React from 'react';
import { Helmet } from 'react-helmet-async';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ExecutionGapTestPage() {
  return (
    <>
      <Helmet>
        <title>The Execution Gap Test · APIG</title>
        <meta name="description" content="Test your next growth decision before the capital moves. Fifteen checks across Validate, Design, and Activate show where the decision is likely to stall." />
      </Helmet>
      <iframe
        src={`${API}/execution-gap-test`}
        title="The Execution Gap Test"
        style={{ width: '100%', height: '100vh', border: 'none', display: 'block' }}
        data-testid="gap-test-iframe"
      />
    </>
  );
}
